// i18n GS-Admin — SPA (I18N_STANDARDS §8, wiring calque inv/hub).
// Initialise i18next via @gs/i18n (namespace 'admin' + 'common' partage au runtime).
// Importe par main.tsx AVANT le render React. Phase A (warning-only) : l'habillage
// est traduit, les pages restent a migrer (lot suivant, I18N_MIGRATION_TRACKER).
import { initI18n } from '@gs/i18n';

import adminFr from './locales/admin.fr.json';
import adminEn from './locales/admin.en.json';

const i18n = initI18n({
  appNamespace: 'admin',
  resources: {
    fr: { admin: adminFr },
    en: { admin: adminEn },
  },
});

export default i18n;
export { useTranslation, Trans, setLocale, SUPPORTED_LOCALES } from '@gs/i18n';
export type { SupportedLocale } from '@gs/i18n';
